<template>
<div class="">
  <transition name="fade">

    <div class="" v-if="widguservis">
      <WidgUser />
    </div>
  </transition>
  <div v-if="widgcalcvis">
    <b-container class="mt-4 text-center" fluid style="background: transparent;">
      <b-row>
        <b-col class="col-2">
          <p>go</p>
        </b-col>
        <b-col class="col-8">
          <b-row>
            <b-col class="paybox mt-2 center" align-self="center">
              <b-row class="estimatebox">
                <b-col sm="5" class="mt-2 textestimate">
                  <div style="vertical-align: middle">
                    <label style="vertical-align: middle" for="input-small" class="text-white adjustFont">Enter Estimate:</label>
                  </div>
                </b-col>
                <b-col class="text-center center mt-2" sm="7" lg="" md="">
                  <div>
                    <b-input-group key="sm" size="sm" class="mb-3" prepend="$">
                      <b-form-input v-model="calcinput" type="number" size="sm" ref="Estimate" name="Estimate" class="paymentBox"></b-form-input>
                    </b-input-group>
                  </div>
                </b-col>
              </b-row>
              <b-row class="radioMonth">
                <b-col class="text-center">
                  <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" :options="options" :aria-describedby="ariaDescribedby" v-on:input="selectedPlan" name="radios-btn-default" buttons></b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-container class="paymentplan">
                <b-row class="text-center" align-v="center">
                  <b-col class="text-center">
                    <p class="offer text-center">
                      ${{updatedPayment}}
                    </p>
                  </b-col>
                </b-row>
              </b-container>
              <b-container class="bv-example-row pt-2 mb-3">
                <b-row class="justify-content-md-center adjustSmall">
                  <b-col class="col-5 text-center">
                    <div>
                      <b-form-select v-model="poSelected" v-on:input="selectedPlan" :options="payOptions" size="sm" class="text-center"></b-form-select>
                    </div>
                  </b-col>
                  <b-col class="col-5 text-center">
                    <b-button class="text-center" size="sm" id="startedbtn" @click="submit">
                      Next
                    </b-button>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

    </b-container>
  </div>
  <transition name="fade">

    <div v-if="visible" class="vue-back-to-top" :style="`bottom:${this.bottom};left:${this.left};`">
      <Main />
    </div>
  </transition>


</div>
</template>

<script>
import Loading from './loading'

let timeout = null

export default {
  name: 'NewCalc',
  components: {
    Loading,
  },
  data() {
    return {
      step: 3,
      title: 'Your payment would be',
      seen: false,
      visible: false,
      cashStatus: false,
      widgcalcvis: true,
      widguservis: false,
      poSelected: 'semimonthly',
      selected: 'radio3',
      options: [{
          text: '6 Months',
          value: 'radio1'
        },
        {
          text: '12 Months',
          value: 'radio2'
        },
        {
          text: '24 Months',
          value: 'radio3'
        },
      ],
      payOptions: [{
          text: 'Monthly',
          value: 'monthly'
        },
        {
          text: 'Semi Monthly',
          value: 'semimonthly'
        },
        {
          text: 'Bi-Weekly',
          value: 'biweekly'
        },
        {
          text: 'Weekly',
          value: 'weekly'
        }
      ],
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      frequencyOfPayments: ['Weekly', 'Bi-weekly', 'Semi-monthly', 'Monthly'],
      amount: '1650',
      paymentType: '3',
      paymentTypeButton: false,
      repairOfferAmount: '1650',
      updatedPayment: '45',
      fees: '87',
      rate: '14.9',
      term: '24',
      vendorOfUser: '',
      calcinput: 1650,
      currentYear: '',
      loanRatio: '',
      approvedLoan: '',
      maxLoanAmount: '',
      finalLoanAmount: '',
      repairAmount: '',
      boundaryLimit: '',
      minimumLoan: '',
      isHidden: true,
      selectedRepair: 'Choose...',
      repairOptions: [
        'Mechanical',
        'Collision',
        'Electrical',
        'Rust',
        'Exhaust',
        'Rims And Tires',
        'Choose...',
      ],
    }
  },
  mounted() {
    // this.focusInput();
    console.log(this)
    this.repairOfferAmount = this.$store.state.userData.repairOfferAmount
    this.calcinput = this.$store.state.userData.repairOfferAmount
    console.log(this.repairOfferAmount);
  },
  created() {
    this.currentYear = new Date().getFullYear()
    this.loanRatio = 1 - (this.currentYear - this.$store.state.userData.year) / 35
    this.approvedLoan = Math.trunc((this.$store.state.userData.marketValue * 0.3 * 0.7) * this.loanRatio)
    this.repairAmount = this.$store.state.userData.repairOfferAmount
    // Check the maximum amount possible to take if the approved loan is lower than the repair offer
    this.maxLoanAmount =
      this.approvedLoan > this.repairAmount ? this.repairAmount : this.approvedLoan

    this.boundaryLimit = this.maxLoanAmount > 10000 ? 10000 : this.maxLoanAmount
    // Check if the customer needs to bring cash because his approved amount doesn't cover the repair offer
    this.minimumLoan =
      this.approvedLoan > this.repairAmount ? 500 : this.repairAmount - this.approvedLoan
    // set default highest loan possible
    this.finalLoanAmount = this.boundaryLimit
    // store the data
    this.$store.state.userData.boundaryAmount = this.approvedLoan > 10000 ? 10000 : this.approvedLoan
    this.$store.state.userData.payment = this.calcPayment
    this.$store.state.userData.paymentTotal = this.finalLoanAmount
    // is the below line important?
    this.$store.state.userData.paymentPeriod = `${this.term} months`
    this.$store.state.userData.term = this.term
  },
  methods: {
    closereseize() {
      if ('parentIFrame' in window)
        window.parentIFrame.size(70);
      return false;
    },
    onpicOne() {
      if ('parentIFrame' in window)
        window.parentIFrame.size(409);
      return false;
    },
    closeWin() {
      return [this.widgcalcvis = false, this.visible = true]
    },
    next() {
      this.$store.state.userData.paymentMethod = this.paymentMethod
      this.widguservis = !this.widguservis
      this.widgcalcvis = false
    },
    // Two function for the spinner
    process() {
      if (timeout) clearTimeout(timeout)
      this.counter++
      this.seen = true
      this.textSeen = false
      timeout = setTimeout(this.fetchHole, 700)
    },
    fetchHole() {
      this.textSeen = true
      this.seen = false
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    process() {
      if (timeout) clearTimeout(timeout)
      this.counter++
      this.seen = true
      this.textSeen = false
      timeout = setTimeout(this.fetchHole, 700)
    },
    fetchHole() {
      this.textSeen = true
      this.seen = false
    },
    focusInput() {
      this.$refs.Estimate.focus();
    },
    next() {
      this.$store.state.userData.selectedRepair = this.selectedRepair
    },
    submit() {
      this.$store.state.userData.payment = this.updatedPayment
      this.$store.state.userData.loanRequested = this.repairOfferAmount
      this.$store.state.userData.repairOfferAmount = this.repairOfferAmount
      this.$store.state.userData.paymentPeriod = this.term
      this.$store.state.step = 4
      this.widguservis = !this.widguservis
      this.widgcalcvis = false
    },
    test() {
      console.log("working");
    },
    calculatePayment(pType) {
      this.term = pType[1]
      if (pType[1] === 6) {
        var myThis = this;
        this.$store.state.userData.paymentPeriod = pType[1];
        console.log('is this logged ' + this.$store.state.userData.paymentPeriod);
        const paymentPeriod = [4.33333333, 2.1666666, 2, 1];
        console.log('calculateP repair offer amount' + myThis.repairOfferAmount);
        const amount = myThis.repairOfferAmount;
        const interest = 0.001;
        const fees = this.fees;
        let allPayments = 0;
        const numpayments = pType[1] * paymentPeriod[pType[0]];
        const rate = (parseFloat(interest) / (paymentPeriod[pType[0]] * 6)) / 100;
        if (amount < 2500) {
          allPayments = (parseFloat(amount) + parseFloat(fees)) + (amount * .009);
        } else {
          allPayments = (parseFloat(amount) + parseFloat(fees)) + (amount * .018);
        };
        const totalmonthlypayment = ((allPayments) * rate * Math.pow(1 + rate, numpayments)) / (Math.pow(1 + rate, numpayments) - 1);

        this.$store.state.userData.numberOfPayments = numpayments;
        console.log('is this' + this.$store.state.userData.numberOfPayments);
        this.$store.state.userData.paymentFees = allPayments - amount;
        console.log('fees' + this.$store.state.userData.paymentFees);
        myThis.updatedPayment = totalmonthlypayment.toFixed(2);
        this.$store.state.userData.payment = totalmonthlypayment;
        this.$store.state.userData.repairOfferAmount = myThis.repairOfferAmount;
        this.$store.state.userData.loanRequested = myThis.repairOfferAmount;
        console.log('before issue');
        // Set the payment period in the store
        if (paymentPeriod[pType[0]] === 1) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[0];
        } else if (paymentPeriod[pType[0]] === 2) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[1];
        } else if (paymentPeriod[pType[0]] === 2.1666666) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[2];
        } else {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[3];
        }
      } else {
        var myThis = this
        const paymentPeriod = [4.33333333, 2.1666666, 2, 1]
        const amount = myThis.repairOfferAmount;
        const interest = myThis.rate;
        const fees = myThis.fees;
        const numpayments = pType[1] * paymentPeriod[pType[0]];
        console.log('nmpayment' + numpayments);
        const rate = (parseFloat(interest) / (paymentPeriod[pType[0]] * 12)) / 100;
        const aprRate = (parseFloat(27.9) / (paymentPeriod[pType[0]] * 12)) / 100;
        console.log('apr rate' + aprRate);
        console.log('amount' + amount);
        const allPayments = parseFloat(amount) + parseFloat(fees);
        let totalmonthlypayment = (parseFloat(amount) * aprRate * Math.pow(1 + aprRate, numpayments)) / (Math.pow(1 + aprRate, numpayments) - 1);
        const noFeesMonthlyPayment = ((allPayments) * rate * Math.pow(1 + rate, numpayments)) / (Math.pow(1 + rate, numpayments) - 1);
        if (noFeesMonthlyPayment > totalmonthlypayment) {
          totalmonthlypayment = noFeesMonthlyPayment
        }
        const paymentFees = totalmonthlypayment - noFeesMonthlyPayment
        console.log('total monthly payment' + totalmonthlypayment);
        console.log('noFeesMonthlyPayment' + noFeesMonthlyPayment);
        console.log(paymentFees);
        this.updatedPayment = totalmonthlypayment.toFixed(2)
        this.$store.state.userData.paymentPeriods = numpayments
        this.$store.state.userData.numberOfPayments = pType[1]
        this.$store.state.userData.paymentFees = paymentFees.toFixed(2)
        console.log("fees to charge " + this.$store.state.userData.paymentFees)
        this.$store.state.userData.loanApr = totalmonthlypayment.toFixed(2)
        this.$store.state.userData.payment = totalmonthlypayment.toFixed(2)
        console.log("New Regular payment: " + totalmonthlypayment.toFixed(2))
        this.$store.state.userData.invoiceBeforeTax = (myThis.repairOfferAmount / 1.12).toFixed(2)
        console.log("invoice before tax: " + this.$store.state.userData.invoiceBeforeTax)
        this.$store.state.userData.PrincipalAmount = myThis.repairOfferAmount * 1 + myThis.fees * 1
        console.log("Principal Amount: " + this.$store.state.userData.PrincipalAmount)
        this.$store.state.userData.newAPR = (1 * totalmonthlypayment).toFixed(4)
        console.log("New APR " + this.$store.state.userData.newAPR)
        this.$store.state.userData.vendorToPay = ((1 * myThis.repairOfferAmount / 1.12) * 1.05).toFixed(2)
        console.log("Vendor topay: " + this.$store.state.userData.vendorToPay)
        if (paymentPeriod[pType[0]] === 1 || paymentPeriod[pType[0]] === 2) {
          var paydate = new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 3)
          this.$store.state.userData.firstPaymentDay = paydate
        } else {
          var myThis = this
          var today = new Date();
          today.setDate(today.getDate() + (12 - today.getDay()) % 7);
          this.$store.state.userData.firstPaymentDay = today
        }
        var myThis = this
        console.log("first payment date " + this.$store.state.userData.firstPaymentDay)
        console.log("Number of Payments" + numpayments);
        this.$store.state.userData.totalPayments = this.$store.state.userData.payment * numpayments
        console.log("Total Payments: " + this.$store.state.userData.totalPayments);
        this.$store.state.userData.loanRequested = myThis.repairOfferAmount
        console.log("Repair Amount: " + this.$store.state.userData.loanRequested);
        this.$store.state.userData.costOfFinancing = (1 * this.$store.state.userData.totalPayments - 1 * myThis.repairOfferAmount).toFixed(2)
        console.log("Repair Cost of Financing: " + this.$store.state.userData.costOfFinancing);
        this.$store.state.userData.frequencyText = myThis.frequencyOfPayments[pType[0]]
        console.log("The frequency is: " + this.$store.state.userData.frequencyText)
        if (paymentPeriod[pType[0]] === 1) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[0]
        } else if (paymentPeriod[pType[0]] === 2) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[1]
        } else if (paymentPeriod[pType[0]] === 2.1666666) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[2]
        } else {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[3]
        }
      };
    }, //close calculate payment function
    selectedPlan() {
      const localThis = this
      //const paymentPeriod = [4.34524, 2.17262, 2, 1]
      console.log('calcinput' + this.calcinput);
      console.log('radio' + this.selected);
      if ((this.calcinput < 10001) && (this.calcinput > 499)) {
        console.log('true');
        this.repairOfferAmount = this.calcinput
        let paymentParams;
        if (this.poSelected === "monthly") {
          if (this.selected === "radio1") {
            paymentParams = [3, 6];
          } else if (this.selected === "radio2") {
            paymentParams = [3, 12];
          } else if (this.selected === "radio3") {
            paymentParams = [3, 24];
          } else if (this.selected === "radio4") {
            paymentParams = [3, 24];
          }
        } else if (this.poSelected === "semimonthly") {
          if (this.selected === "radio1") {
            paymentParams = [2, 6];
          } else if (this.selected === "radio2") {
            paymentParams = [2, 12];
          } else if (this.selected === "radio3") {
            paymentParams = [2, 24];
          } else if (this.selected === "radio4") {
            paymentParams = [2, 24];
          }
        } else if (this.poSelected === "biweekly") {
          if (this.selected === "radio1") {
            paymentParams = [1, 6];
          } else if (this.selected === "radio2") {
            paymentParams = [1, 12];
          } else if (this.selected === "radio3") {
            paymentParams = [1, 24];
          } else if (this.selected === "radio4") {
            paymentParams = [1, 24];
          }
        } else if (this.poSelected === "weekly") {
          if (this.selected === "radio1") {
            paymentParams = [0, 6];
          } else if (this.selected === "radio2") {
            paymentParams = [0, 12];
          } else if (this.selected === "radio3") {
            paymentParams = [0, 24];
          } else if (this.selected === "radio4") {
            paymentParams = [0, 24];
          }
        }

        if (paymentParams) {
          this.calculatePayment.call(this, paymentParams);
        }

      } else if (this.calcinput > 10000) {
        console.log('true');

        this.updatedPayment = '10K Max.'
      } else if (this.calcinput < 500) {
        console.log('true');

        this.updatedPayment = '500 Min.'
      }
    },
  },

  watch: {
    calcinput() {
      const localThis = this
      if ((this.calcinput < 10001) && (this.calcinput > 499)) {
        localThis.repairOfferAmount = localThis.calcinput
        console.log("this is repairofferamount" + localThis.repairOfferAmount);
        if ((localThis.poSelected === "monthly") && (localThis.selected === "radio2")) {
          //12 months and Semi monthly [3,12]
          localThis.calculatePayment.call(this, [3, 12]);
        } else if ((localThis.poSelected === "semimonthly") && (localThis.selected === "radio2")) {
          localThis.calculatePayment.call(this, [2, 12]);
        } else if ((localThis.poSelected === "monthly") && (localThis.selected === "radio3")) {
          localThis.calculatePayment.call(this, [3, 24]);
        } else if ((localThis.poSelected === "semimonthly") && (localThis.selected === "radio3")) {
          localThis.calculatePayment.call(this, [2, 24]);
        } else if ((localThis.poSelected === "semimonthly") && (localThis.selected === "radio1")) {
          localThis.calculatePayment.call(this, [2, 6]);
        } else if ((localThis.poSelected === "monthly") && (localThis.selected === "radio1")) {
          localThis.calculatePayment.call(this, [3, 6]);
        } else if ((localThis.poSelected === "semimonthly") && (localThis.selected === "radio4")) {
          localThis.calculatePayment.call(this, [2, 24]);
        } else if ((localThis.poSelected === "monthly") && (localThis.selected === "radio4")) {
          localThis.calculatePayment.call(this, [3, 24]);
        } else if ((localThis.poSelected === "semimonthly") && (localThis.selected === "radio2")) {
          localThis.calculatePayment.call(this, [0, 12]);
        } else if ((localThis.poSelected === "monthly") && (localThis.selected === "radio2")) {
          localThis.calculatePayment.call(this, [1, 12]);
        } else if ((localThis.poSelected === "semimonthly") && (localThis.selected === "radio3")) {
          localThis.calculatePayment.call(this, [0, 24]);
        } else if ((localThis.poSelected === "monthly") && (localThis.selected === "radio3")) {
          localThis.calculatePayment.call(this, [1, 24]);
        } else if ((localThis.poSelected === "monthly") && (localThis.selected === "radio1")) {
          localThis.calculatePayment.call(this, [1, 6]);
        } else if ((localThis.poSelected === "semimonthly") && (localThis.selected === "radio1")) {
          localThis.calculatePayment.call(this, [0, 6]);
        } else if ((localThis.poSelected === "monthly") && (localThis.selected === "radio4")) {
          localThis.calculatePayment.call(this, [1, 24]);
        } else if ((localThis.poSelected === "semimonthly") && (localThis.selected === "radio4")) {
          localThis.calculatePayment.call(this, [0, 24]);
        } else if ((this.poSelected === "biweekly") && (this.selected === "radio2")) {
          this.calculatePayment.call(this, [1, 12]);
        } else if ((this.poSelected === "weekly") && (this.selected === "radio2")) {
          this.calculatePayment.call(this, [0, 12]);
        } else if ((this.poSelected === "biweekly") && (this.selected === "radio3")) {
          this.calculatePayment.call(this, [1, 24]);
        } else if ((this.poSelected === "weekly") && (this.selected === "radio3")) {
          this.calculatePayment.call(this, [0, 24]);
        } else if ((this.poSelected === "weekly") && (this.selected === "radio1")) {
          this.calculatePayment.call(this, [0, 6]);
        } else if ((this.poSelected === "biweekly") && (this.selected === "radio1")) {
          this.calculatePayment.call(this, [1, 6]);
        }
      } else if (this.calcinput > 10000) {
        this.updatedPayment = '10K Max.'
      } else if (this.calcinput < 500) {
        this.updatedPayment = '500 Min.'
      }
    },
    //The new function
    paymentTypeButton() {
      this.selectedPlan()
    },

  },
}
</script>

<style scoped>
.btn-group>.btn-group:not(:first-child)>.btn,
.btn-group>.btn:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  background-color: orange !important;
}

.btn {
  background-color: #F15B22 !important;
}

.b-form-radio-group {
  background-color: #F15B22 !important;

}

h4 {
  font-size: 2em;
  color: grey;
  text-transform: uppercase;
}

span {
  border-right: 0.05em solid;
  animation: caret 1s steps(1) infinite;
}

@keyframes caret {
  50% {
    border-color: transparent;
  }
}

.belowit {
  margin-bottom: 10px;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #cff7d7 !important;
  opacity: 1;
}

.input-group .form-control:not(:last-child) {
  border-right: 0;
  font-size: 1rem;
  padding-right: 0;
}

.container-fluidback {
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;
  background: #FFF;
}

.background {
  background: linear-gradient(132deg, #E6EFED, #DBFCF6, #FFFFFF);
  background-size: 400% 400%;
  animation: Gradient 15s ease infinite;
  position: relative;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  padding: 0;
  margin: 0;
}

.cube {
  position: absolute;
  top: 80vh;
  left: 45vw;
  width: 10px;
  height: 10px;
  border: solid 1px #D7D4E4;
  transform-origin: top left;
  transform: scale(0) rotate(0deg) translate(-50%, -50%);
  animation: cube 12s ease-in forwards infinite;
}

.cube:nth-child(2n) {
  border-color: #FFF;
}

.paymentBox {
  font-size: 1rem;
  font-weight: bold;
}

.paymentBoxTwo {
  font-size: 1rem;
  font-weight: bold;
}

.cube:nth-child(2) {
  animation-delay: 2s;
  left: 25vw;
  top: 40vh;
}

.cube:nth-child(3) {
  animation-delay: 4s;
  left: 75vw;
  top: 50vh;
}

.cube:nth-child(4) {
  animation-delay: 6s;
  left: 90vw;
  top: 10vh;
}

.cube:nth-child(5) {
  animation-delay: 8s;
  left: 10vw;
  top: 85vh;
}

.cube:nth-child(6) {
  animation-delay: 10s;
  left: 50vw;
  top: 10vh;
}

@keyframes Gradient {
  0% {
    background-position: 0 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}

@keyframes cube {
  from {
    transform: scale(0) rotate(0deg) translate(-50%, -50%);
    opacity: 1;
  }

  to {
    transform: scale(20) rotate(960deg) translate(-50%, -50%);
    opacity: 0;
  }
}


.container-fluid {
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;
  background: #FFF;
}

.radioMonth {
  margin-top: 15px;
}

.titlefont {
  font-family: 'Raleway', sans-serif;
  color: #F15B22 !important;
  font-size: 2rem;
}

.subtitlefont {
  color: #009579 !important;
  font-size: 2rem !important;

}

.offer {
  color: white !important;
  font-size: 3.5rem !important;
}

.esti {
  display: inline-block;
}

.text-label {
  line-height: 1.5;
  font-size: 1.5rem;
  font-weight: 400;
  font-family: Poppins;
}

.estinumber {
  height: 5rem;
}

#startedbtn {
  background-color: #f6c215 !important;
  color: black;
  white-space: nowrap;
}

.mainback {
  position: relative;
}

.center {

  vertical-align: middle;

}

.phonepos {
  position: absolute;
}

#btnx {
  background-color: #02b349;
  border-color: white;
  border-width: medium;
}

#btnx:hover {
  background-color: green;
}

.paybox {
  background-color: #1870C8;
  border-radius: 25px;
}

.estimatebox {
  background-color: #326BA4;
  border-radius: 15px 15px 15px 15px;
  height: 65px;
}

.smimgres {
  max-width: 70%;
  max-height: 70%;
  object-fit: contain;
}

#home {
  min-height: 500px;
}

@media (max-width: 349.9px) {
  #home {
    min-height: 950px;
    padding-top: 150px;
    margin-left: 0;

  }

  h4 {
    font-size: 0.5rem;
  }

  .row {
    margin-right: 0 !important;
  }

  .mobile {
    margin-left: 0;
    padding-left: 0;
  }

  .radioMonth {
    padding-top: 110px;
  }

  .paymentplan {
    padding-bottom: 15px;
  }

  .ml-4,
  .mx-4 {
    margin-left: 0.3rem !important;
  }

  .container {
    margin-left: 0;
    padding-left: 0;
  }

  .smimgres {
    display: none;
  }

  .titlefont {
    font-size: 1.5rem !important;
  }

  .subtitlefont {
    font-size: 1rem !important;
  }

  .textestimate {
    text-align: left !important;
  }

  .months {
    padding-top: 90px;
  }

  p.offer {
    line-height: 60px !important;
    margin-bottom: 0 !important;

  }

  .estimatebox {
    background-color: #326BA4;
    border-radius: 15px 15px 15px 15px;
    height: 100px;
  }
}

@media (min-width: 350px) and (max-width: 486.5px) {
  #home {
    min-height: 850px;
    padding-top: 150px;
    margin-left: 0;

  }

  h4 {
    font-size: 0.8rem;
  }

  .row {
    margin-right: 0 !important;
  }

  .mobile {
    margin-left: 0;
    padding-left: 0;
  }

  .radioMonth {
    padding-top: 110px;
  }

  .paymentplan {
    padding-bottom: 15px;
  }

  .ml-4,
  .mx-4 {
    margin-left: 0.3rem !important;
  }

  .container {
    margin-left: 0;
    padding-left: 0;
  }

  .smimgres {
    display: none;
  }

  .titlefont {
    font-size: 1.5rem !important;
  }

  .subtitlefont {
    font-size: 1rem !important;
  }

  .textestimate {
    text-align: left !important;
  }

  .months {
    padding-top: 90px;
  }

  p.offer {
    line-height: 60px !important;
    margin-bottom: 0 !important;

  }

  .estimatebox {
    background-color: #326BA4;
    border-radius: 15px 15px 15px 15px;
    height: 100px;
  }
}

@media (min-width: 486.6px) and (max-width: 560px) {
  #home {
    min-height: 650px !important;
    padding-top: 100px !important;
  }

  h4 {
    font-size: 1rem;
  }

  .smimgres {
    display: none !important;
  }

  .radioMonth {
    padding-top: 0 !important;
  }

  .ml-4,
  .mx-4 {
    margin-left: 0.6rem !important;
  }

  .months {
    padding-top: 30px !important;
  }

  p.offer {
    line-height: 60px !important;
    margin-bottom: 0 !important;

  }

  .estimatebox {
    height: 100px !important;
  }
}

@media (min-width: 561px) and (max-width: 767px) {
  #home {
    min-height: 550px !important;
    padding-top: 100px;
  }

  h4 {
    font-size: 1.2rem;
  }

  .smimgres {
    display: none;
  }

  .radioMonth {
    padding-top: 0;
  }

  .ml-4,
  .mx-4 {
    margin-left: 0.6rem !important;
  }

  .months {
    padding-top: 30px;
  }

  p.offer {
    line-height: 60px !important;
  }

  .estimatebox {
    height: 50px;
  }
}

@media (min-width: 768px) and (max-width: 979px) {
  #home {
    max-height: 700px;
  }

  .textestimate {
    text-align: right !important;
  }

  .smimgres {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  p.offer {
    line-height: 60px !important;
  }

  .mainSpacing {
    margin-top: 40px !important;
  }
}

@media (min-width: 980px) and (max-width: 1399px) {
  #home {
    max-height: 600px !important;

  }

  .zeroInt {
    display: none !important;
  }

  .textestimate {
    text-align: right !important;
  }

  .paymentplan {
    height: 70px;
  }

  .mainSpacing {
    margin-top: 50px !important;
  }

  p.offer {
    line-height: 60px !important;
  }
}

@media (min-width: 1400px) {
  #home {
    max-height: 800px !important;

  }

  .zeroInt {
    display: none !important;
  }

  .textestimate {
    text-align: right !important;
  }

  .mainSpacing {
    margin-top: 30px !important;
  }

  p.offer {
    line-height: 60px !important;
  }
}

h2 {
  line-height: 1.5;
  font-size: 2rem;
  font-weight: 900;
  font-family: Poppins;
  color: #326BA4;
  margin-bottom: 0 !important;
}

h3 {
  font-size: 1.5rem;
}

h5 {
  text-transform: none;
  font-size: 18px;
  font-weight: 300;
}

.container {
  max-width: 1600px;
}
</style>



// WEBPACK FOOTER //
// src/components/new_calc.vue